/* eslint-disable react-hooks/exhaustive-deps */
import { Form } from "react-bootstrap";
import { Modulo } from "../../../types/admin-usuarios/Modulo";
import { useEffect, useState } from "react";
import { Loader, Table, toaster } from "rsuite";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { PerfilModulo, Permiso } from "../../../types/admin-usuarios/PerfilModulo";
import { getMenu } from "../../../libs/menuPermissions/getMenu";
import { useStore } from "../../../context/AppContext";
import { checkPermission } from "../../../libs/menuPermissions/permissions";

const { Column, HeaderCell, Cell } = Table;

const classname = "user-select-none text-dark  fw-bold fs-6";

export default function TablaModulos({ id, modulos, permisos } : { id: string, modulos: Modulo[], permisos: PerfilModulo[] }){
    const [loading, setLoading] = useState<boolean>(false);
    const [objetoPermisos, setObjetoPermisos] = useState<any>({});
    const { state } = useStore();

// console.log(modulos);
    useEffect(()=>{
        if(permisos.length > 0){
            const ob: any = {};
            permisos.forEach((p: PerfilModulo)=>{
                ob[p.module._id as string||""] = {_id: p._id, permission: p.permission};
            });
            setObjetoPermisos(ob);
        }else setObjetoPermisos({});
    }, [permisos]);

    function savePermiso(idMod: string, permiso: Permiso){
        const cpObPr = { ...objetoPermisos };
        cpObPr[idMod] = permiso;
        setObjetoPermisos(cpObPr);
    }

    return(
        <div>            
            <Table
                isTree
                defaultExpandAllRows={true}
                cellBordered={false}
                rowKey="_id"
                autoHeight
                data={modulos as any}
                affixHeader
            >
                <Column flexGrow={1} minWidth={200} fullText fixed>
                    <HeaderCell className={classname}>Módulo</HeaderCell>
                    <Cell dataKey="module">
                        { rowData => `${rowData.name}` }
                    </Cell>
                </Column>
                <Column align="center" >
                    <HeaderCell className={classname}>Todos</HeaderCell>
                    <Cell>
                        { rowData => (<CheckCell id={id} stload={setLoading} modulo={rowData} permiso={objetoPermisos[rowData._id]} savePermiso={savePermiso} action="all" disabled ={checkPermission(state, "update")}/>) }
                    </Cell>
                </Column>
                <Column align="center" >
                    <HeaderCell className={classname}>Crear</HeaderCell>
                    <Cell>
                        { rowData => (<CheckCell id={id} stload={setLoading} modulo={rowData} permiso={objetoPermisos[rowData._id]} savePermiso={savePermiso} action="create" disabled ={checkPermission(state, "update")}/>) }
                    </Cell>
                </Column>
                <Column align="center" >
                    <HeaderCell className={classname}>Leer</HeaderCell>
                    <Cell>
                        { rowData => (<CheckCell id={id} stload={setLoading} modulo={rowData} permiso={objetoPermisos[rowData._id]} savePermiso={savePermiso} action="read" disabled ={checkPermission(state, "update")}/>) }
                    </Cell>
                </Column>
                <Column align="center" >
                    <HeaderCell className={classname}>Editar</HeaderCell>
                    <Cell>
                        { rowData => (<CheckCell id={id} stload={setLoading} modulo={rowData} permiso={objetoPermisos[rowData._id]} savePermiso={savePermiso} action="update" disabled ={checkPermission(state, "update")}/>) }
                    </Cell>
                </Column>
                <Column align="center" >
                    <HeaderCell className={classname}>Eliminar</HeaderCell>
                    <Cell>
                        { rowData => (<CheckCell id={id} stload={setLoading} modulo={rowData} permiso={objetoPermisos[rowData._id]} savePermiso={savePermiso} action="delete" disabled ={checkPermission(state, "update")}/>) }
                    </Cell>
                </Column>
            </Table>

            { loading && <Loader backdrop vertical style={{zIndex: 5}} /> }
        </div>
    )
}

function CheckCell({id, stload, modulo, permiso, savePermiso, action, disabled=false} : 
    {id: string, stload: any, modulo: any | Modulo, permiso: any, savePermiso: Function, action: 'all' | 'read' | 'create'| 'update' | 'delete', disabled?: boolean} ){
    const {state, dispatch} = useStore();

    function getState(){
        if(modulo && permiso) {
            if(action === "all") return permiso.permission.read && permiso.permission.create && permiso.permission.update && permiso.permission.delete;
            else return permiso.permission[action];
        }
        return false;
    }

    async function save({checked}: any){
        stload(true);
        const params = {
            module: modulo._id, 
            permission: permiso ? { ...permiso.permission } : {
                read: false,
                create: false,
                update: false,
                delete: false,
            } 
        }

        if(action === "all"){
            params.permission = {
                "create": checked,
                "read": checked,
                "update": checked,
                "delete": checked
            }
        }else{
            params.permission[action] = checked;
        }

        delete params.permission._id;
        const rute = permiso ? `/perfiles/update_permission_module/${permiso._id}` : `/perfiles/add_module/${id}`;
        const res = await peticionBack(permiso? params.permission : params, rute, "PUT", true, toaster);
        if(res){
            savePermiso(modulo._id, {_id: res._id, permission: res.permission });
            if(state.user.currentperfil?._id === id) getMenu(dispatch, state.user.currentperfil);
        }
        stload(false);
    }

    if(modulo.children && action !== "all") return null;

    return(
        <Form.Check.Input
            aria-label={action}
            id={`${modulo._id}-${action}`}
            name={`${modulo._id}-${action}`}
            type="checkbox"
            onChange={({target}: any)=> save(target)}
            checked={getState()}
            color="danger"
            style={{width: "20px", height: "20px"}}
            className="m-0"
            disabled={!disabled}
        />
    )
}